var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var self = locals || {};const language = self.htmlWebpackPlugin.options.data.locale
pug_html = pug_html + "\u003Cdiv class=\"Revo\" id=\"revo\"\u003E\u003Ciframe" + (" id=\"revo-iframe\""+pug.attr("src", "https://host.drawbotics.com/revo/villa/index.html?lang=" + language, true, true)+" width=\"100%\" height=\"85vh\" style=\"border:none;\"") + "\u003E\u003C\u002Fiframe\u003E\u003C!--.revo-btn--\u003E\u003C!--    a.btn.btn-red(href=\"#\") Découvrez en 3D--\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/revo.pug
// module id = 20
// module chunks = 0